<template>
  <v-dialog :value="model.active" width="400" persistent>
    <v-card v-if="selected">
      <div class="d-flex justify-space-between align-center pr-2">
        <v-card-title class="text-h6 font-weight-bold py-2">
          <v-icon left>mdi-plus</v-icon>
          Add to plan
        </v-card-title>
        <v-btn icon @click="closeDialog"><v-icon>fa-close</v-icon></v-btn>
      </div>
      <v-divider></v-divider>
      <v-card-subtitle class="font-weight-light mt-2 py-0">
        Choose one or more plans to assign selected corrosion tags to. You can select multiple plans if needed.
      </v-card-subtitle>
      <v-card-text class="pt-5 pb-0">
        <v-form v-model="model.valid">
          <v-autocomplete
            v-model="selected.plans"
            :items="taskTypes"
            item-text="name"
            item-value="id"
            label="Select Plan"
            chips
            deletable-chips
            multiple
            small-chips
            outlined
            clearable
            color="primary"
            :rules="[formRules.required]"
            placeholder="Select Plan..."></v-autocomplete>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="red" elevation="0" text @click="closeDialog"> close </v-btn>
        <v-spacer></v-spacer>
        <v-btn elevation="0" :disabled="!model.hasChanges" @click="discard"> discard </v-btn>
        <v-btn
          color="primary"
          :loading="updateLoading || model.saving"
          elevation="0"
          @click="saveChanges"
          :disabled="!model.valid || !model.hasChanges">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { log, warn, error } from '@/utils/debugLogger';
  import { $isEqual } from '@Utils';
  import formRules from '@Share/config/form-rules';
  import { mapGetters } from 'vuex';
  import ganttService from '@/features/Task/service/gantt.service';
  import { $formatDate } from '@/utils';

  export default {
    name: 'add-corrosion-to-plan',
    data() {
      return {
        selected: {},
        selectedCemented: {},
        selectedTags: [],
        formRules,
        model: {
          active: false,
          loading: false,
          valid: true,
          hasChanges: false,
          saving: false,
        },
      };
    },
    computed: {
      ...mapGetters('TASK', {
        updateLoading: 'GET_UPDATE_LOADING',
      }),
      taskTypes: {
        get() {
          return this.$store.getters['TASK_MANAGER/GET_ENTRIES_BY_USER'];
        },
      },
      facility: {
        get() {
          return this.$store.getters['FACILITY/GET_FACILITY'];
        },
      },
    },
    methods: {
      open(tags) {
        this.model.active = true;
        if (tags) this.selectedTags = structuredClone(tags);
        this.cementSelected();
      },
      async saveChanges() {
        this.model.saving = true;

        let tasks = [];
        let promises = [];

        // For each selected plan
        this.selected.plans.forEach((taskTypeId) => {
          let taskType = this.taskTypes.find((o) => o.id == taskTypeId);
          let statusId = null;
          if (taskType && taskType.statuses.length > 0) {
            statusId = taskType.statuses[0]?.id;
          }

          // For each selected corrosion tag
          this.selectedTags.forEach((tag) => {
            let promise = ganttService.getNextId().then((e) => {
              let task = {
                text: tag.name, // Use tag name directly
                start_date: $formatDate(Date.now(), 'YYYY-MM-DD'),
                end_date: $formatDate(Date.now(), 'YYYY-MM-DD'),
                friendlyId: e.data.nextId,
                forgeTagsIds: [tag.id], // Use existing tag ID
                progress: 0,
                typeId: taskTypeId,
                statusId: statusId,
              };
              tasks.push(task);
            });

            promises.push(promise);
          });
        });

        Promise.all(promises).then(() => {
          this.$store
            .dispatch('TASK/CREATE_MULTIPLE', tasks)
            .then(() => {
              this.$dialog.notify.success('Successfully added to plan');
              this.$store.dispatch('CORROSION_ANALYSER/GET');
              this.cementSelected();
              this.closeDialog();
            })
            .catch((err) => {
              error('Failed to add to plan', err);
              this.$dialog.notify.error('Failed to add to plan');
            })
            .finally(() => {
              this.model.saving = false;
            });

          // Refresh facility tags
          this.$store.dispatch('fetchAllAMISTagsDbids', {
            assetId: this.$route.params.id,
            fetched: false,
          });
        });
      },
      reset() {
        this.model.active = false;
        this.selected = {};
        this.selectedCemented = {};
        this.selectedTags = [];
      },
      closeDialog() {
        if (this.model.hasChanges) {
          const answer = window.confirm('You have unsaved changes on this page! leave anyway?');
          if (answer) {
            this.reset();
            this.discard();
          }
        } else {
          this.reset();
        }
      },
      discard() {
        this.selected = structuredClone(this.selectedCemented);
        this.model.hasChanges = false;
      },
      cementSelected() {
        this.selectedCemented = structuredClone(this.selected);
        this.checkForChanges();
      },
      checkForChanges() {
        if (!this.model.active) return;

        this.model.hasChanges = !$isEqual(this.selected, this.selectedCemented);
      },
    },
    watch: {
      selected: {
        handler() {
          this.checkForChanges();
        },
        deep: true,
      },
    },
  };
</script>
